module.exports = __webpack_public_path__ + "static/media/alternator-stering-and-replacement.4fd8cafa.svg";